module.exports = __webpack_public_path__ + "img/commission.516b1ac7.png";